














import { Component, Vue, Inject } from 'nuxt-property-decorator';

import { IconExpand } from '@/icons';

@Component({
  components: {
    IconExpand,
  },
})
export default class ModalImageGalleryItem extends Vue {
  @Inject()
  registerImage!: (instance: Vue) => void;

  @Inject()
  openModalOnClick!: (instance: Vue) => void;

  created () {
    this.registerImage(this);
  }
}
